import { SuperModel, FieldConfig } from './super-model';

export class ImageUploadModel extends SuperModel {
	isReadonly: boolean;
	isHidden: boolean;
	fieldType: FieldType;
	fieldColumn: string;
	isRequired: boolean;
	additionalMetaData: MetadataBuilder = {};
	value: Array<{
		file: any
	}>
	constructor(
		field
	) {
		super(field);
		this.additionalMetaData = field.additionalMetaData;
		if ([null, undefined].includes(this.additionalMetaData)) {
			this.additionalMetaData = {};
		}
		if (!this.additionalMetaData.hasOwnProperty('supportedType')) {
			this.additionalMetaData.supportedType = null;
		}
		if (!this.additionalMetaData.hasOwnProperty('fileSize')) {
			this.additionalMetaData.fileSize = null;
		}
		if (!this.additionalMetaData.hasOwnProperty('showLabel')) {
			this.additionalMetaData.showLabel = true;
		}
		if (!this.additionalMetaData.hasOwnProperty('changeEventEmit')) {
			this.additionalMetaData.changeEventEmit = true;
		}
		if (!this.additionalMetaData.hasOwnProperty('crop')) {
			this.additionalMetaData.crop = false;
		}
	}
}

type FieldType = 'imageUpload';

interface MetadataBuilder {
	supportedType?: string | Array<string>;
	fileSize?: number | string;
	showLabel?: boolean;
	fieldConfig?: FieldConfig;
	changeEventEmit?: boolean;
	thumbnail?: string;
	max?: number;
	crop?: boolean;
}
